export const extraFeature = {
  homepage: 'homepage',
  theme: 'theme',
  topPage: 'top_page',
  menuTemplate: 'menu_customize',
  onlinePayment: 'online_payment',
  separateOrder: 'separate_order',
  buffetMenu: 'buffet_menu',
  recommendMenu: 'recommend_menu',
  toppingImage: 'topping_image',
  hideQuantityZeropricedDishes: 'hide_quantity_zeropriced_dishes',
  linkage_items: 'linkage_items',
}
